import axios from "axios";
import { API } from "./apiList";

export default axios.create({
  baseURL: API(),
});